import { render, staticRenderFns } from "./TrainerItem.vue?vue&type=template&id=c621b79a&scoped=true&"
import script from "./TrainerItem.vue?vue&type=script&lang=js&"
export * from "./TrainerItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c621b79a",
  null
  
)

export default component.exports